import { $Qll } from "graditify-utils";
import { $Q } from "../utils/query-selector";

// eslint-disable-next-line no-undef
Shopify.queryParams = {};

/**
 * Update sort_by query parameter on select change
 */
export const defaultSortBy = () => {
  $Qll(".order-by-options").forEach((option) => {
    option.addEventListener(
      'click',
      () => {
        /* eslint-disable no-undef */
        const prevUrl = new URL(window.location.href);
        const subcollection = prevUrl.searchParams.get("subcollection")
        Shopify.queryParams.sort_by = option.getAttribute("value");
        if (subcollection) {
          Shopify.queryParams.subcollection = subcollection
        }
        location.search = new URLSearchParams(Shopify.queryParams).toString();
        /* eslint-enable no-undef */
    });
  })
}

/**
 * Listens for click events on filter options in the mobile view and
 * toggles the checked state of the corresponding checkbox.
 */
function listenFilterMobile() {
  const filterForm = $Q("#filter-mobile");
  const labelOptions = $Qll("label", filterForm);
  labelOptions.forEach((label) => {
    label.addEventListener("click", () => {
      const checkbox = $Q("input[type='checkbox']", label);
      if (checkbox.getAttribute("checked") === "checked") {
        checkbox.setAttribute("checked", "unchecked");
        label.classList.remove("active-filter");
      } else {
        checkbox.setAttribute("checked", "checked");
        label.classList.add("active-filter");
      }
    })
  })
}

/**
 * Preserve existing query parameters
 */
// eslint-disable-next-line func-names
(function () {
  /* eslint-disable no-undef */
  if (location.search.length) {
    const params = location.search.substring(1).split('&');

    for (let i = 0; i < params.length; i++) {
      const keyValue = params[i].split('=');

      if (keyValue.length) {
        Shopify.queryParams[
          decodeURIComponent(keyValue[0])
        ] = decodeURIComponent(keyValue[1]);
      }
    }
  }
  /* eslint-enable no-undef */
}());

// eslint-disable-next-line func-names
(function () {
  /* eslint-disable no-undef */
  const sort = $Q('#sort-by')
  const sortModal = $Q(".select-options-container")
  const filterForm = $Q("#filter");
  const filterButton = $Q("#filter-form-submit")

  document.addEventListener('click', (e) => {
    const clickModal = sortModal.contains(e.target)
    const clickButton = sort.contains(e.target)
    const clickFilter = filterForm.contains(e.target)
    const clickFilterButton = $Q("#filter-open").contains(e.target)

    if (!clickModal && !clickButton) {
      sortModal.classList.add('hidden')
    }

    if (!clickFilter && !clickFilterButton) {
      filterForm.classList.add("hidden")
    }
  })
  sort.addEventListener("click", () => {
    sortModal.classList.toggle("hidden");
  })

  filterForm.addEventListener("change", () => {
    if (!filterForm.classList.contains("hidden")) {
      filterButton.click();
    }
  })

  listenFilterMobile()
}());
